export const casConfig = {
  casBaseUrl: import.meta.env.VITE_CAS_BASE_URL,
  serviceUrl: import.meta.env.VITE_APP_BASE_URL + "/sso-callback",
};

export function redirectToCasLogin() {
  // window.location.href = `${
  //   casConfig.casBaseUrl
  // }/cas/login?service=${encodeURIComponent(casConfig.serviceUrl)}`;

  window.location.href = `${import.meta.env.VITE_API_BASE_URL}/api/v1/auth/login`;
}

export function getCasTicket(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("ticket");
}
